import React, { useEffect, useState } from 'react';
import axios  from 'axios';
import parse from "html-react-parser";
import { variables } from './Variables.js';
export default function SmallArticle_Ar() {
  const jsonUrl = variables.basename_url + 'updates/index/Coinsinsight_HomeAr_TrendingNews.json';
  const [isLoading, setNisLoading] = useState(false);
  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    Get_Data();
  }
  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data() {
    JsonArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        for (let i = 0; i <= 0 && i < response.data.length; i++) {
          JsonArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split('T')[0],
            news_imagename: response.data[i].image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),
            Category: response.data[i].Category,
          })
        }
      })
  }
  useEffect(() => {
  setNisLoading(true);
    refda();
  }, [])
  return (
    <>
      {JsonArray.map(da =>
        <div key={da.news_title}  >
          <div className="post-news-item-2 mt-40 "style={{direction:"rtl"}}>
            <div className="post-news-thumb">
              <a href={da.link}>
                <img src={da.news_imagename} alt="" />
              </a>
            </div>
            <div className="post-news-content">
              <h3 className="title"><a href={da.link}>{da.news_title}</a></h3>
              <p>{parse(da.Description)}</p>
              <div className="meta-post-2-style" style={{ direction: "ltr"}}>
                <div className="meta-post-date">
                  <span>{da.news_date}</span>
                </div>
                <div className="meta-post-categores">
                  <a >{da.Category}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}



